
import { defineComponent } from '@vue/composition-api';
import { Video } from '@fc/angie-ui';
import { metaData } from '~/configuration/metaData';
import HeroSection from '~/components/v5/HeroSection.vue';
import SplitView from '~/components/SplitView.vue';
import Section from '~/components/v5/Section.vue';
import SectionHeader from '~/components/v5/SectionHeader.vue';
import CoachesSection from '~/components/v5/system/CoachesSection.vue';
import TheTechSection from '~/components/v5/system/TheTechSection.vue';
import TheEquipmentSection from '~/components/v5/system/TheEquipmentSection.vue';
import VideoHeroSection from '~/components/v5/system/VideoHeroSection.vue';
import FCImage from '~/components/FCImage.vue';

export default defineComponent({
  name: 'TheSystemPage',
  components: {
    HeroSection,
    SplitView,
    SectionHeader,
    CoachesSection,
    TheTechSection,
    TheEquipmentSection,
    VideoHeroSection,
    Video,
    Section,
    FCImage,
  },
  head: {
    ...metaData.home, // TODO: update with system page metadata
    link: [
      {
        rel: 'preconnect',
        href: 'https://fonts.googleapis.com',
      },
      {
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com',
        crossorigin: true,
      },
      {
        rel: 'stylesheet',
        href: 'https://fonts.googleapis.com/css2?family=Orbitron:wght@400..900&display=swap',
        media: 'print',
        onload: "this.media='all'",
      },
    ],
  },
  setup() {
    const heroData = {
      title: 'The FightCamp System',
      subtitle: 'Elite, fight-tested coaches. Clear round goals with AI Motion Tech. Equipment purpose-built for your home.',
      videoUrl: 'https://cdn-b.joinfightcamp.com/videos/TheSystem_Hero_Video_NoAudio_001.mp4',
      mobileVideoUrl: 'https://cdn-b.joinfightcamp.com/videos/Hero_Video_System_9x16.mp4',
    };

    const videoHeroData = {
      headline: 'AI Motion Tracking',
      subheadline: 'Originally developed for Olympic teams, our motion technology captures every strike — processing speed, power, and precision to help you train with the accuracy of a pro.',
      videoUrl: 'https://cdn-b.joinfightcamp.com/videos/The_System_AI_TRACKING_TEMP_003.mp4',
    };

    return {
      heroData,
      videoHeroData,
    };
  },
});
